var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaximize = function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.879 7.1H8.515l6.424 6.425-1.414 1.414L7.1 8.515v5.364h-2V6.1l1-1h7.779zm10.667 10.668v5.364l-6.425-6.425-1.414 1.414 6.425 6.425h-5.364v2h7.778l1-1v-7.778z",
    clipRule: "evenodd"
  })));
};
export default SvgMaximize;